import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';

import { reportingConfig } from 'components/Dashboards/Reporting/reportingConfig';
import { ReportingHomePageHeader } from 'components/pages/ReportingHomePage/components/ReportingHomePageHeader/ReportingHomePageHeader';
import { ReportsHome } from 'components/widgets/ReportsHome/ReportsHome';

export const ReportingHomePage = () => {
    useFullStoryPageView({ pageName: reportingConfig.reporting.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <ReportingHomePageHeader />
            </HeaderWrapper>

            <MainContent>
                <ReportsHome />
            </MainContent>
        </PageContainer>
    );
};
